import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  itemsByName: {},
  pagination: { page: 1, pageSize: 10, totalItems: 0, totalPages: 1 },
  numDueToExpire: 0,
  numExpired: 0,
  listLoading: false,
  addLoading: false,
  editLoading: false,
  deleteLoading: false,
  error: null,
  types: [],
  suppliers: [],
  lookupsLoading: false,
  lookupsError: null,
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    // .................... List / Filter ...........................
    fetchInventoryStart(state) {
      state.listLoading = true;
      state.error = null;
    },
    fetchInventorySuccess(state, action) {
      state.listLoading = false;
      state.itemsByName = action.payload.itemsByName;
      state.pagination = action.payload.pagination;
    },
    fetchInventoryFailure(state, action) {
      state.listLoading = false;
      state.error = action.payload;
    },

    // .................... Add ...........................
    addInventoryStart(state) {
      state.addLoading = true;
      state.error = null;
    },
    addInventorySuccess(state) {
      state.addLoading = false;
    },
    addInventoryFailure(state, action) {
      state.addLoading = false;
      state.error = action.payload;
    },

    // .................... Edit ...........................
    editInventoryStart(state) {
      state.editLoading = true;
      state.error = null;
    },
    editInventorySuccess(state) {
      state.editLoading = false;
    },
    editInventoryFailure(state, action) {
      state.editLoading = false;
      state.error = action.payload;
    },

    // .................... Delete ...........................
    deleteInventoryStart(state) {
      state.deleteLoading = true;
      state.error = null;
    },
    deleteInventorySuccess(state) {
      state.deleteLoading = false;
    },
    deleteInventoryFailure(state, action) {
      state.deleteLoading = false;
      state.error = action.payload;
    },

    // .................... Expiry stats ...........................
    fetchExpiryStatsStart(state) {
      state.error = null;
    },
    fetchExpiryStatsSuccess(state, action) {
      state.numDueToExpire = action.payload.numDueToExpire;
      state.numExpired = action.payload.numExpired;
    },
    fetchExpiryStatsFailure(state, action) {
      state.error = action.payload;
    },

     // .................... Add/Edit form lookups (types, suppliers) ........
    fetchInventoryLookupsStart(state) {
      state.lookupsLoading = true;
      state.lookupsError = null;
    },
    fetchInventoryLookupsSuccess(state, action) {
      state.lookupsLoading = false;
      state.types = action.payload.types;
      state.suppliers = action.payload.suppliers;
    },
    fetchInventoryLookupsFailure(state, action) {
      state.lookupsLoading = false;
      state.lookupsError = action.payload;
    },
  },
});

export const {
  fetchInventoryStart,
  fetchInventorySuccess,
  fetchInventoryFailure,
  addInventoryStart,
  addInventorySuccess,
  addInventoryFailure,
  editInventoryStart,
  editInventorySuccess,
  editInventoryFailure,
  deleteInventoryStart,
  deleteInventorySuccess,
  deleteInventoryFailure,
  fetchExpiryStatsStart,
  fetchExpiryStatsSuccess,
  fetchExpiryStatsFailure,
  fetchInventoryLookupsStart,
  fetchInventoryLookupsSuccess,
  fetchInventoryLookupsFailure,
} = inventorySlice.actions;

export default inventorySlice.reducer;